export default [
  {
    name: 'partner-create',
    path: '/partners/create',
    component: () => import('@/views/partners/PartnerManage')
  },
  {
    name: 'partner-edit',
    path: '/partners/:id/edit',
    component: () => import('@/views/partners/PartnerManage')
  },
  {
    name: 'partner-view',
    path: '/partners/:id/view',
    component: () => import('@/views/partners/PartnerManage')
  },
  {
    name: 'partner-find',
    path: '/partners/find',
    component: () => import('@/views/partners/PartnerFind')
  }
]



// WEBPACK FOOTER //
// ./src/router/routePartners.js